export default function(ac, app) {
    var entity = app.getEntity('KorisnikOrdinacija');

    entity.listView()
        .title('Korisnici')
        .icon('<i class="fa fa-user fa-3x"></i>')
        .fields([
            ac.field('first_name')
                .label('Ime')
                .cssClasses(['col-md-2']),
            ac.field('last_name')
                .label('Prezime')
                .cssClasses(['col-md-2']),
            ac.field('email'),
            ac.field('username'),
        ])
        .listActions([
            'delete'
        ]);

    entity.creationView()
        .title('Unos korisnika')
        .fields([
            {
                key:'username',
                type: 'hInput',
                templateOptions: {
                    label: 'Korisničko ime',
                    required: true,
                    focus: true
                },
            },
            {
                key:'first_name',
                type: 'hInput',
                templateOptions: {
                    label: 'Ime',
                    required: true
                }
            },
            {
                key:'last_name',
                type: 'hInput',
                templateOptions: {
                    label: 'Prezime',
                    required: true
                }
            },
            {
                key:'email',
                type: 'hInput',
                templateOptions: {
                    label: 'Email',
                }
            },
            {
                key:'password1',
                type: 'hInput',
                templateOptions: {
                    label: 'Zaporka',
                    type: 'password',
                    required: true,
                }
            },
            {
                key:'password2',
                type: 'hInput',
                templateOptions: {
                    label: 'Potvrdite',
                    type: 'password',
                    required: true,
                }
            }
        ]);

    return entity;
}



// WEBPACK FOOTER //
// ./app/components/korisnikOrdinacija/config.js